import React, { Component } from 'react';
import Loading from '../../Loading.js'
import ControlProjects from './ControlProjects.js';
import { getListProjects } from '../../../Api/ExtranetActions.js'

declare var globalSns;

class ExtranetProjects extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getListProjects(globalSns.languageId, (data) => {
            this.setState({
                listprojects: data
            });
        });
    }

    render() {
        if (this.state.listprojects == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <ControlProjects projects={this.state.listprojects} 
                        onNavigateToProject={(row) => this.props.onNavigate("extranetProjectsFiche", row.id, row.title)}
                        onNavigateToCandidates={(row) => this.props.onNavigate("extranetProjectsCandidates", row.id, row.title)}
                        onNavigateToDocuments={(row) => this.props.onNavigate("extranetProjectsDocuments", row.id, row.title)}
                        onNavigateToMessages={(row) => this.props.onNavigate("extranetProjectsMessages", row.id, row.title)}
                    />
                </div>                
            </div>
        );
    }
}

export default ExtranetProjects;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetProjects.js